import PropTypes from 'prop-types';
import {
  Navigate,
  useLocation
} from 'react-router-dom';

import useIsUserDeniedByRol from '../hooks/useIsUserDeniedByRol';

export function RequireRole({ children, roles = [] }) {
  const location = useLocation();
  const isDenied = useIsUserDeniedByRol(roles);

  if (isDenied) {
    return <Navigate to="/403" state={{ from: location }} replace />;
  }

  return children;
}

export default RequireRole;

RequireRole.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string)
};
